export const izjava_povj_izvrsitelj= {
  templateId: 91.1,
  category: 9,
  templateTitle: "Izjava o povjerljivosti osobe zadužene od izvršitelja obrade",
  templateDescription: `Izvršitelj obrade kojemu je voditelj obrade povjerio poslove obrade osobnih podataka dužan je osigurati povjerljivost pri obradi osobnih podataka, a obveza voditelja obrade je da to dokaže po potrebi.`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Ukoliko je voditelj obrade povjerio izvršitelju obrade provođenje poslova obrade osobnih podataka u njegovo ime, izvršitelj obrade osigurava da su se osobe ovlaštene za obradu osobnih podataka obvezale na poštovanje povjerljivosti ili da podliježu zakonskim obvezama o povjerljivosti.</p>
    <p>Voditelj obrade odgovoran je za usklađenost s načelima povjerljivosti i cjelovitosti koja određuju da podaci moraju biti obrađivani na način kojim se osigurava odgovarajuća sigurnost osobnih podataka, uključujući zaštitu od neovlaštene ili nezakonite obrade te od slučajnog gubitka, uništenja ili oštećenja primjenom odgovarajućih tehničkih ili organizacijskih mjera, a navedeno mora i dokazati po potrebi.</p>
     <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>UREDBA (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ (Opća uredba o zaštiti podataka).</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Opće uredbe o zaštiti podataka,',
            signature: 'Odgovorna osoba:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Ime i prezime",
              },
              {
                type: "input",
                required: false,
                placeholder: "Broj službenog telefona",
              },
              {
                type: "input",
                required: false,
                placeholder: "Službena e-mail adresa",
              }],
            suffix: ' (u daljnjem tekstu: Odgovorna osoba),',
        }
    ],
    
  headline: "daje sljedeću",
  title: "IZJAVU O POVJERLJIVOSTI",

  noArticleNumbers: true,

  articles: [
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            { type: "text", content: "kojom ja, gore navedeni, kao osoba koja u ime Izvršitelja obrade" },
            { type: "input", content: "", required: true,  placeholder: "Poslovni subjekt"},
            { type: "text", content: "," },
            { type: "input", content: "", required: true,  placeholder: "Ulica i kućni broj"},
            { type: "text", content: "," },
            { type: "input", content: "", required: true,  placeholder: "Mjesto"},
            { type: "text", content: "," },
            { type: 'text', content: 'OIB:' },
            { type: "input",  required: true,},
            { type: "text", content: "obavlja poslove obrade osobnih podataka, izjavljujem da ću sukladno odredbama Opće uredbe o zaštiti podataka pri obradi osobnih podataka:  \r\n" }
          ],
        },
            
            {type: "text",
              mandatory: true,
              content: "- iste obrađivati na način kojim se osigurava odgovarajuća sigurnost osobnih podataka, uključujući zaštitu od neovlaštene ili nezakonite obrade te od slučajnog gubitka, uništenja ili oštećenja primjenom odgovarajućih tehničkih ili organizacijskih mjera,"},
            {
              type: "text",
              mandatory: true,
              content: "\r\n- postupati povjerljivo s osobnim podacima koji će mi tijekom rada za Izvršitelja obrade biti dostupni te da neću iznositi iste u javnosti, niti ih na drugi način učiniti dostupnim trećim osobama, osim  ako je to određeno zakonom.",
            },
          ]
        },
  {
    title: "",
    mandatory: false,
    dummy: true,
    statements: [
      {
        type: "text",
        mandatory: true,
        editable: true,
        content: "Ovu izjavu o povjerljivosti sam u potpunosti pročitao i ona predstavlja moju pravu volju te istu u znak suglasnosti potpisujem.	"},
      ]
  },
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
  {
    mandatory: true,
    static: true,
    type: 3,  // signatures   
    statements: [],
  },

],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/91.1_izjava_povj_izvrsitelj.ts